import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import esLocale from "date-fns/locale/es";
import {DatePicker, DatePickerProps, MobileDatePicker} from "@mui/x-date-pickers";
import { Control, Controller } from "react-hook-form";
import React, { ReactNode } from "react";

interface ControlledDatePickerProps extends DatePickerProps<any> {
    control: Control<any>,
    name: string,
    disabled?: boolean,
    label?: ReactNode | null,
    fullWidth?: boolean
    clearable?: boolean,
    mobile?: boolean,
}

export const ControlledDatePicker = ({
    control, name,
    ...props
}: ControlledDatePickerProps
) => {
    const PickerComponent = props.mobile ? MobileDatePicker : DatePicker

    return (
        <Controller
            control={control}
            name={name || ''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                    <PickerComponent
                        {...props}
                        value={value}
                        onChange={onChange}
                        slotProps={{
                            textField: {
                                size: 'small',
                                helperText: error && error.message,
                                error: !!error,
                                fullWidth: props.fullWidth
                            },
                            actionBar: {
                                actions: props.clearable ? ['accept', 'clear'] : [],
                            }
                        }}
                    />
                </LocalizationProvider>
            )}
        />
    )
}
